import { render, staticRenderFns } from "./DyestuffFormList1.vue?vue&type=template&id=0386b954&"
import script from "./DyestuffFormList1.vue?vue&type=script&lang=ts&"
export * from "./DyestuffFormList1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports